import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import http from '../components/http/http';
import { useTranslation } from 'react-i18next';

const VerifyEmail: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage(t('tokenNotFoundInTheLink'));
      return;
    }
    http.verifyEmail(token)
      .then((data) => {
        if (data.success) {
          setStatus('success');
          setMessage(data.message || t('emailSuccessfullyVerified'));
          setTimeout(() => navigate('/login'), 3000);
        } else {
          setStatus('error');
          setMessage(data.error || data.message || t('verificationFailed'));
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage(t('networkError'));
      });
  }, [searchParams, navigate]);

  return (
    <div style={{ maxWidth: 400, margin: '60px auto', padding: 24, border: '1px solid #eee', borderRadius: 8, textAlign: 'center' }}>
      <h2>{t('emailVerification')}</h2>
      {status === 'pending' && <p>{t('verifyingYourEmail')}</p>}
      {status !== 'pending' && <p style={{ color: status === 'success' ? 'green' : 'red' }}>{message}</p>}
      {status === 'success' && <p>{t('redirectingToLogin')}</p>}
    </div>
  );
};

export default VerifyEmail; 